// Angular Acceleration units with conversion factors to radian per second squared (rad/s²)
export const accelerationAngularUnits = [
  { id: 'radian-per-second-squared', name: 'Radian/Second²', symbol: 'rad/s²', plural: 'Radians/Second²', factor: 1 },
  { id: 'radian-per-minute-squared', name: 'Radian/Minute²', symbol: 'rad/min²', plural: 'Radians/Minute²', factor: 0.00027777778 },
  { id: 'revolution-per-second-squared', name: 'Revolution/Second²', symbol: 'rev/s²', plural: 'Revolutions/Second²', factor: 6.283185307 },
  { id: 'revolution-per-minute-squared', name: 'Revolution/Minute²', symbol: 'rev/min²', plural: 'Revolutions/Minute²', factor: 0.001745329252 },
  { id: 'revolution-per-minute-per-second', name: 'Revolution/Minute/Second', symbol: 'rev/(min·s)', plural: 'Revolutions/Minute/Second', factor: 0.1047197551 },
  { id: 'degree-per-second-squared', name: 'Degree/Second²', symbol: '°/s²', plural: 'Degrees/Second²', factor: 0.01745329252 },
  { id: 'degree-per-minute-squared', name: 'Degree/Minute²', symbol: '°/min²', plural: 'Degrees/Minute²', factor: 4.848136811e-6 },
];

export const popularAccelerationAngularConversions = [
  { from: 'radian-per-second-squared', to: 'degree-per-second-squared' },
  { from: 'degree-per-second-squared', to: 'radian-per-second-squared' },
  { from: 'revolution-per-second-squared', to: 'radian-per-second-squared' },
  { from: 'revolution-per-minute-squared', to: 'radian-per-second-squared' },
  { from: 'radian-per-second-squared', to: 'revolution-per-minute-per-second' },
  { from: 'degree-per-minute-squared', to: 'radian-per-second-squared' },
];

export const getUnitById = (id) => accelerationAngularUnits.find(unit => unit.id === id);

export const convertAccelerationAngular = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
